class EventNotification {
  private targetOrigin: string;
  private sourceWindow: Window;
  constructor(targetOrigin = '*', sourceWindow: Window) {
    this.targetOrigin = targetOrigin;
    this.sourceWindow = sourceWindow || window;
  }

  notify(event: string, payload: Record<string, unknown>, module = ''): void {
    const message = {
      action: `ap${!!module ? '-' + module : module}-${event}`,
      payload,
    };
    this.sourceWindow.parent.postMessage(message, this.targetOrigin);
  }
}

export default EventNotification;
